import { defineComponent as e, openBlock as o, createBlock as r, normalizeProps as n, guardReactiveProps as a, withCtx as p, renderSlot as i, createElementVNode as l } from "vue";
import s from "../CdrIcon.vue.mjs";
const C = /* @__PURE__ */ l("path", {
  role: "presentation",
  d: "M21,16.5 L21,18.3 C21,18.9627417 20.5522847,19.5 20,19.5 L4,19.5 C3.44771525,19.5 3,18.9627417 3,18.3 L3,16.5 L21,16.5 Z M20,17.625 L4,17.625 L4,18.375 L20,18.375 L20,17.625 Z M19,5 C19.5522847,5 20,5.44771525 20,6 L20,16 L4,16 L4,6 C4,5.44771525 4.44771525,5 5,5 L19,5 Z M18.75,6.25 L5.25,6.25 L5.25,14.75 L18.75,14.75 L18.75,6.25 Z M14,7.5 C14.5522847,7.5 15,7.94771525 15,8.5 L15,8.5 L15,12.5 C15,13.0522847 14.5522847,13.5 14,13.5 L14,13.5 L9,13.5 C8.44771525,13.5 8,13.0522847 8,12.5 L8,12.5 L8,11.820164 C8,11.1048996 8.5050245,10.4891393 9.2064593,10.3491665 L9.2064593,10.3491665 L11.012,9.988 L11.0347085,8.48536228 C11.0421376,7.97788106 11.4266392,7.56324136 11.9191501,7.50659631 L11.9191501,7.50659631 L12.0346013,7.5 L14,7.5 Z M14,8.5 L12.0346013,8.5 L12.0007659,10.8112728 L9.4021531,11.3298315 C9.1683415,11.3764891 9,11.5817426 9,11.820164 L9,11.820164 L9,12.5 L14,12.5 L14,8.5 Z"
}, null, -1), m = /* @__PURE__ */ e({
  name: "VirtualOutfitting",
  __name: "virtual-outfitting",
  props: {
    props: {
      type: Object
    }
  },
  setup(L) {
    return (t, c) => (o(), r(s, n(a(L.props)), {
      default: p(() => [i(t.$slots, "default"), C]),
      _: 3
    }, 16));
  }
});
export {
  m as default
};
